<button mat-icon-button (click)="groundCuboid()" matTooltip="Stick to ground">
  <mat-icon class="material-symbols-outlined"> vertical_align_bottom </mat-icon>
</button>
